<template>
  <div class="flex min-h-screen flex-col">
    <AppHeader />
    <main class="flex-1">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import { brand, contact, siteUrl } from '@/config/site'
import { useJsonLd } from '@/composables/useJsonLd'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

useJsonLd(
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: brand.name,
    url: siteUrl,
    description: brand.description,
    email: contact.email,
  },
  'organization',
)
</script>
